import { Component, OnInit, ElementRef, OnDestroy, ViewChild  } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ReactiveFormsModule, FormBuilder} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { logisticaModulo as diccionarios, logisticaModulo} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { ITiposViajesShort, ITrackingCarga, ITrackingDocumentos, ITrackingViajeByChofer, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { ColDef, GridApi, ColumnApi } from 'ag-grid-community';


@Component({
  selector: 'app-upload-csv-planificacion',
  templateUrl: './upload-csv-planificacion.component.html',
  styleUrls: ['./upload-csv-planificacion.component.css']
})

export class UploadCsvPlanificacionComponent implements OnInit {

  titulo = 'Carga de Planificación';
  mostrarFormulario = false;

  gridApi       : GridApi;
  gridColumnApi : ColumnApi;
  columnDefs    : ColDef[];
  
  frameworkComponents: any;
  rowSelection      : any;
  rowData           : any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading     : boolean = false;
  listaVacia  : boolean = true;

  modulo: any = logisticaModulo;

  DAT_BTNS  = this.modulo.button.buttonsNombre;
  DAT_BTNCSS = this.modulo.button.buttonsCss;
  DAT_MSG   = this.modulo.mensajes;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;

  usuario: string;

  constructor(
        public fb             : FormBuilder,
        private utilServicesLF: UtilsService,
        private catalogo      : CatalogosLogisticaService,
        private logisticaApi  : LogisticaService,
  ) { }

  ngOnInit(): void {
    //let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.formulario = this.fb.group({ multipart : ['', [Validators.required]]});
    
    this.usuario = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
    this.cargarGrid();
  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      { headerName: 'ESTADO', sortable: true, filter: true, width: 150,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) { return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO'; }
      },
      { field: 'tipoPlanificacionId', sortable: true, filter: true, resizable: true },
      { field: 'tipo',                sortable: true, filter: true, resizable: true },
      { field: 'proveedor',           sortable: true, filter: true, resizable: true },
      { field: 'proveedorNombre',     sortable: true, filter: true, resizable: true },
      { field: 'placa',               sortable: true, filter: true, resizable: true },
      { field: 'furgon',              sortable: true, filter: true, resizable: true },
      { field: 'chofer',              sortable: true, filter: true, resizable: true },
      { field: 'choferCelular',       sortable: true, filter: true, resizable: true },
      { field: 'choferNombre',        sortable: true, filter: true, resizable: true },
      { field: 'origen',              sortable: true, filter: true, resizable: true },
      { field: 'centroOrigenNombre',  sortable: true, filter: true, resizable: true },
      { field: 'destino',             sortable: true, filter: true, resizable: true },
      { field: 'centroDestinoNombre', sortable: true, filter: true, resizable: true },
      { field: 'fechaLlegada',        sortable: true, filter: true, resizable: true },
      { field: 'horaLlegada',         sortable: true, filter: true, resizable: true },
      { field: 'error',               sortable: true, filter: true, resizable: true, width: 600, cellStyle: this.changeRowColor.bind(this)},
    ];
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }


  regresar() {
    this.loading = false;
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  nombreFileCargado: string;
  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this.utilServicesLF.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.nombreFileCargado = file.name;
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    formData.append('creado', "SYSTEM");
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {

    const payload = this.setFormData(this.formulario.value);
    console.info("envio de datos", payload);

    this.utilServicesLF.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo? ',
        text: 'Carga de ' + this.nombreFileCargado,
        action: 'Enviar',
        funcion: this.logisticaApi.preCargaViajeCsv(payload),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this.rowData = this.rowData.map(e => ({ ...e, creadoPor: this.usuario }));

    this.utilServicesLF.confirmarSincronoPromesaNormal(
      {
        title   : 'Esta seguro que desea guardar el siguiente listado?',
        text    : 'PLAINIFICACION',
        action  : 'Guardar',
        funcion : this.logisticaApi.saveCargaViajeCsv(this.rowData),
        loading : true,
        context : this,
      }
    ).then((res: any) => {
      this.utilServicesLF.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this.utilServicesLF.mensajeErrorVisto(err.error.message, true, 3000);
    });

    this.loading = false;
  }

  downloadCsvFormato() {
    let namePlantilla: string = "plantilla-carga-plabificacion.csv";
    let cabecera: any[] =[['TIPO', 'PROVEEDOR_ID', 'PLACA', 'CHOFER_CEDULA', 'RECURSO_FURGON', 'ORIGEN', 'DESTINO', 'FECHA_LLEGADA', "HORA_LLEGADA"]];

    const dataMockup: any[] = [
      { TIPO: 'TRASLADO PTA', PROVEEDOR_ID: '500000004', PLACA: 'MBA-111', CHOFER_CEDULA: '131200000',  RECURSO_FURGON: 'TR-001', ORIGEN: 'CODIGO CENTRO', DESTINO: 'CODIGO CENTRO', FECHA_LLEGADA: '2026-05-07', HORA_LLEGADA: '20:30' },
      { TIPO: 'TRASLADO PTA', PROVEEDOR_ID: '500000004', PLACA: 'MBA-111', CHOFER_CEDULA: '131200000',  RECURSO_FURGON: 'TR-001', ORIGEN: 'CODIGO CENTRO', DESTINO: 'CODIGO CENTRO', FECHA_LLEGADA: 'yyyy-MM-dd', HORA_LLEGADA: '20:30' }
    ];

    this.utilServicesLF.exportCSV(cabecera, dataMockup, namePlantilla);
  }

  downloadDataCsv() {
    let data: any = [];
    let name: string = "REGISTRO_ERRORES.csv";

    let cabecera: any[] = [[
      'TIPO_PLANIFICACION_ID',
      'TIPO',
      'PROVEEDOR_ID',
      'PROVEEDOR_NOMBRE',
      'PLACA',
      'RECURSO_FURGON',
      'CHOFER_CEDULA',
      'CHOFER_NOMBRE',
      'CHOFER_CELULAR',
      'ORIGEN_ID',
      'CENTRO_ORIGEN_NOMBRE',
      'DESTINO_ID',
      'CENTRO_DESTINO_NOMBRE',
      'FECHA_LLEGADA',
      'HORA_LLEGADA',
      'USUARIO',
      'ESTADO',
      'Error'
    ]];

    let clonData = this.rowData.map((x) => Object.assign({}, x));

    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            tipoPlanificacionId : e.tipoPlanificacionId,
            tipo                 : e.tipo,
            proveedor            : e.proveedor,
            proveedorNombre      : e.proveedorNombre,
            placa                : e.placa,
            furgon               : e.furgon,
            chofer               : e.chofer,
            choferNombre         : e.choferNombre,
            choferCelular        : e.choferCelular,
            origen               : e.origen,
            centroOrigenNombre   : e.centroOrigenNombre,
            destino              : e.destino,
            centroDestinoNombre  : e.centroDestinoNombre,
            fechaLlegada         : e.fechaLlegada,
            horaLlegada          : e.horaLlegada, 
            creadoPor            : this.usuario,
            estado              : (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            error               : (e.error === undefined || e.error === null) ? '' : e.error,
          }
        );
      }
    });

    this.utilServicesLF.exportCSV(cabecera, data, name);
    this.utilServicesLF.mensajeOKToast('El archivo csv se exportó correctame.');
  }


}
